/** @jsxImportSource @emotion/react */
import { tsOfficePhone } from 'constants/misc'

const PaperworkInsuranceReview = () => {
  return (
    <div className="payment-success">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="payment-success__content text-center">
              <div className="d-flex align-items-center justify-content-center">
                <i className="fa fa-check text-success mr-3" css={{ fontSize: 30 }} />
                <h1>Thank You — We Received Your Paperwork</h1>
              </div>
              <div>
                <p css={{ fontSize: 18 }}>
                  You let us know that the insurance we have on file is not correct, so we have
                  paused your paperwork here. Our insurance team will review the information you
                  provided and follow up with you once it has been processed.
                </p>
                <p css={{ fontSize: 18 }}>
                  There is nothing else for you to do right now. Once your insurance has been
                  reviewed, we will text you a secure link to complete the final step.
                </p>
                <p css={{ fontSize: 18 }}>Questions? Call our office at {tsOfficePhone}.</p>
              </div>
              <div className="payment-success__content__button">
                <button className="btn btn-primary" onClick={() => window.close()}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaperworkInsuranceReview
